import {
    deleteRequest,
    putRequest,
    getRequest,
    postRequest,
 } from "../../utils/api";
 
 export const apiStatistical = (data) => {
    return postRequest('/api/charge-statistics/report', data)
 }
 export const apiStatisticalReportData = (data) => {
    return postRequest('/api/charge-statistics/report', data)
 }
 export const apiStatisticalReportDailyData = (data) => {
   return postRequest('/api/charge-statistics/report-daily', data)
}

export const apiStatisticalReportStationData = (data) => {
   return postRequest('/api/charge-statistics/report-station', data)
}


 export const apiStatisticalExport = (data) => {
    return postRequest('/api/charge-statistics/report', data)
 }